import cn from 'clsx';
import { FC, ReactNode } from 'react';

import { ColorPalette } from '../../../../types';
import { colorToTailwindTheme } from '../../../../utils';
import BasicBadge, { BadgeColorType } from '../../../Badge/Basic/Basic';
import Icon from '../../../Icon';
import StateItem, { StateItemType } from '../../StateItem/StateItem';

import s from './SettingListItem.module.scss';

interface TextModel {
  color?: ColorPalette;
}

interface TitleModel extends TextModel {
  state?: StateItemType;
  badge?: string;
  badgeColor?: BadgeColorType;
}

export interface SettingListItemProps {
  left?: ReactNode;
  title: string;
  subText?: string;
  border?: boolean;
  right?: ReactNode;
  titleOptions?: TitleModel;
  subTextOptions?: TextModel;
  listIcon?: boolean;
}

const SettingListItem: FC<React.PropsWithChildren<React.PropsWithChildren<SettingListItemProps>>> = ({
  left,
  right,
  title,
  subText,
  titleOptions,
  subTextOptions,
  border = false,
  listIcon = false
}) => {
  const titleColor = colorToTailwindTheme(titleOptions?.color || 'gray.700', 'text');
  const subTextColor = colorToTailwindTheme(subTextOptions?.color || 'gray.500', 'text');

  return (
    <div
      className={cn(s.wrap, {
        [s.border as string]: border
      })}
    >
      {left && <div className={s.left}>{left}</div>}

      <div className={s.center}>
        <p className={cn(s.title, titleColor)}>
          <span className={s.titleText}>{title}</span>
          {titleOptions?.badge && <BasicBadge text={titleOptions.badge} color={titleOptions.badgeColor || 'violet'} />}
          {titleOptions?.state && <StateItem type={titleOptions.state} className={s.state_item} />}
        </p>
        {subText && <p className={cn(s.subText, subTextColor)}>{subText}</p>}
      </div>

      {right && <div className={s.right}>{right}</div>}
      {listIcon && <Icon type="listin-right" color="gray.300" width={18} height={24} />}
    </div>
  );
};

export default SettingListItem;
